/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DownloadDocumentsMutation from '../graphql/mutations/DownloadDocumentsMutation.js';

export const useDownloadDocumentsMutation = () => {
  return useCommitMutation(DownloadDocumentsMutation, {
    dataProp: 'downloadDocuments_M_simulation_recap'
  });
};

export default useDownloadDocumentsMutation;
